/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChatMessage } from '../models/ChatMessage';
import type { TChatRequest } from '../models/TChatRequest';
import type { TListMyChannelsResponse } from '../models/TListMyChannelsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChatService {
    /**
     * Chat
     * @param requestBody
     * @returns ChatMessage TChatResponse
     * @throws ApiError
     */
    public static chat(
        requestBody: TChatRequest,
    ): CancelablePromise<ChatMessage> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List the requesting user's own channels (TM engagement channels + their group's Support channel).
     * Declared before the `{id}` routes below so `/chat/channels` isn't swallowed by `/chat/{id}`.
     * @returns TListMyChannelsResponse TListMyChannelsResponse
     * @throws ApiError
     */
    public static listMyChannels(): CancelablePromise<TListMyChannelsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chat/channels',
        });
    }
    /**
     * Mark a channel as read for the requesting user
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static markChannelRead(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat/channels/{id}/read',
            path: {
                'id': id,
            },
        });
    }
}
